import { render, staticRenderFns } from "./ImportContract.vue?vue&type=template&id=5b1bbc12"
import script from "./ImportContract.vue?vue&type=script&lang=js"
export * from "./ImportContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports